export default __webpack_public_path__ + "static/media/escalera_telescopica.5bd3d98f.png";